<template>
<div class="search">
     <Button type="primary" icon="ios-search" class="search-btn">搜索</Button>
</div>
</template>
<script>
export default {
    name:'SearchBtn'
}
</script>
<style scoped>
.search{
    display: inline;
}

.search-btn {
    width:104px;
    height:32px;
    background:rgba(31,108,221,1);
    border-radius:4px;
    font-size: 14px;
    padding: 0;

    line-height: 30px;
    color:rgba(255,255,255,1);
}
</style>


